export const SET_AI_ONLY_ENABLED = 'SET_AI_ONLY_ENABLED' as const;

export const setAiOnlyEnabled = (enabled: boolean) => ({
  type: SET_AI_ONLY_ENABLED,
  payload: { enabled },
});
